const SCROLL_STATE_BUFFER = 600;
const SCROLL_STATE_BUFFER_MANUAL = 600;

export default class ScrollController {
    static SCROLL_DIRECTION = {
        forward: 'forward',
        backwards: 'backwards',
        none: 'none',
    };

    getScrollStateBuffer = () => (this.options.manualScrollDirection ? SCROLL_STATE_BUFFER_MANUAL : SCROLL_STATE_BUFFER);

    constructor(
        duration,
        fps,
        options = {
            reverseAllowed: false,
            onTime: () => {},
            fixedUpdate: false,
            manualScrollDirection: false,
        }
    ) {
        this.duration = duration * 1000;
        this.fps = fps;
        this.frameDuration = parseFloat((1000 / fps).toFixed(2));
        this.options = options;
        this.scrollDirection = ScrollController.SCROLL_DIRECTION.forward;

        this.intervalId = null;
        this.intervalTime = 0;
        this.delta = 0;
        this.scrollStateWait = this.getScrollStateBuffer();
        this.init();
    }

    Start() {
        this.lastTick = performance.now();

        this.active = true;
        window.requestAnimationFrame(this.tick);
        this.scrollDirection = ScrollController.SCROLL_DIRECTION.none;

        if (this.options.manualScrollDirection) return;

        const scrollableElement = document.body;
        scrollableElement.addEventListener('wheel', (e) => {
            if (e.deltaY < 0) {
                this.SetScrollDirection(ScrollController.SCROLL_DIRECTION.backwards);
            } else if (e.deltaY > 0) {
                this.SetScrollDirection(ScrollController.SCROLL_DIRECTION.forward);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey) return;

            switch (event.code) {
                case 'ArrowUp':
                    this.SetScrollDirection(ScrollController.SCROLL_DIRECTION.backwards);
                    break;
                case 'ArrowDown':
                    this.SetScrollDirection(ScrollController.SCROLL_DIRECTION.forward);
                    break;
                default:
            }
        });
    }

    Stop() {
        this.init();
    }

    SetScrollDirection(scrollDirection) {
        this.scrollDirection = scrollDirection;
        this.scrollStateWait = this.getScrollStateBuffer();
    }

    init = () => {
        this.active = false;
        this.time = 0;
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    };

    tick = (time) => {
        this.delta = time - this.lastTick;
        this.lastTick = time;

        this.resetScrollDirection();

        this.update();

        if (this.active) {
            window.requestAnimationFrame(this.tick);
        }
    };

    update = () => {
        if (!this.active) return;

        if (this.options.onTime !== null) {
            if (this.options.fixedUpdate) {
                this.updateFixed();
            } else {
                if (this.scrollDirection === ScrollController.SCROLL_DIRECTION.forward) {
                    this.time += this.delta;
                    this.time = this.time > this.duration ? this.duration : this.time;
                } else if (this.scrollDirection === ScrollController.SCROLL_DIRECTION.backwards) {
                    this.time -= this.delta;
                    this.time = this.time < 0 ? 0 : this.time;
                }

                const time = this.time / 1000;
                this.options.onTime(time, this.scrollDirection);
            }
        }
    };

    updateFixed = () => {
        if (this.scrollDirection === ScrollController.SCROLL_DIRECTION.none) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        } else if (this.intervalId === null) {
            this.intervalId = setInterval(() => {
                this.intervalTime =
                    this.scrollDirection === ScrollController.SCROLL_DIRECTION.forward
                        ? this.intervalTime + this.frameDuration
                        : this.intervalTime - this.frameDuration;

                if (this.scrollDirection === ScrollController.SCROLL_DIRECTION.backwards && this.intervalTime < 0) {
                    this.intervalTime = 0;
                }

                this.options.onTime(this.intervalTime / 1000, this.scrollDirection);
            }, this.frameDuration);
        }
    };

    resetScrollDirection = () => {
        if (this.scrollStateWait < 0) {
            this.scrollDirection = ScrollController.SCROLL_DIRECTION.none;
            return;
        }

        this.scrollStateWait -= this.delta;
    };
}
